"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./ContentWrapper.css");
var ContentWrapper = (function (_super) {
    __extends(ContentWrapper, _super);
    function ContentWrapper(props) {
        return _super.call(this, props) || this;
    }
    ContentWrapper.prototype.render = function () {
        return (React.createElement("div", { className: "p-content-wrapper", "data-tag": this.props.tag || null }, this.props.children));
    };
    return ContentWrapper;
}(React.Component));
ContentWrapper.defaultProps = {
    tag: '',
    children: []
};
exports.default = ContentWrapper;
//# sourceMappingURL=ContentWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ../player-content-wrapper/build/control/ContentWrapper.js
// module id = 132
// module chunks = 0 1